<template>
  <layout>
    <div class="searchBox">
      <Input
        v-model.trim="search"
        clearable
        placeholder="请输入域名信息"
        maxlength="30"
        @on-keyup="change"
        @on-enter="searchEvnet"
      />

      <div class="search-btn f-18 flx-row-c-c" @click="searchEvnet">
        <img src="@/assets/image/seach-icon.png" alt="" />
        查询
      </div>
    </div>
    <div class="section">
      <div v-if="!noData && !noResult" class="whios-info">
        <div class="whois-left">
          <div class="whios-title">
            域名
            <span style="font-size: 30px; font-weight: bold; color: #e9570f"
              >{{ info.domain }}</span
            >
            注册信息
            <span style="float: right; cursor: pointer" @click="refreshWhois">获取最新信息</span>
          </div>
          <div style="margin-top: 16px">
            <div class="flx-row-s-s info-item" style="margin-top: 16px">
              <div class="info-title">域名:</div>
              <div class="info-text">{{ info.domain }}</div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">域名状态:</div>
              <div class="info-text">
                <p v-for="item in info.status" :key="item">
                  {{ item }}
                </p>
              </div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">注册联系电话:</div>
              <div class="info-text">{{ info.contactPhone }}</div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">注册者联系电子邮箱:</div>
              <div class="info-text">{{ info.mail }}</div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">注册商:</div>
              <div class="info-text">{{ info.registrar }}</div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">DNS服务器:</div>
              <div class="info-text">
                <p v-for="(item, index) in info.dns" :key="item">
                  DNS{{ index + 1 }}：{{ item }}
                </p>
                <p v-if="info.dns.length === 0">暂无数据</p>
              </div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">注册日期:</div>
              <div class="info-text">{{ info.registerDateTime }}</div>
            </div>
            <div class="flx-row-s-s info-item">
              <div class="info-title">过期时间:</div>
              <div class="info-text">{{ info.expirationDateTime }}</div>
            </div>
          </div>
        </div>
        <div class="whois-right">
          <div class="eng-title">
            <span class="title-inner">详细英文注册信息</span>
          </div>
          <div class="content" v-html="info.details || ''"></div>
        </div>
      </div>
      <div v-if="noData" class="whios-info">
        <div class="whois-left" style="width: 100%; font-size: 18px">
          <span class="c-o">“{{ search }}”</span>未查询到whois信息<span
            style="color: #2d8cf0; margin-left: 5px; cursor: pointer"
            @click="toRegister(search)"
            >>>立即注册域名</span
          >
        </div>
      </div>

      <div v-if="noResult" class="whios-info">
        <div class="whois-left" style="width: 100%; font-size: 18px">
          <div>
            <div style="font-size: 20px; color: #333">未查询到whois信息</div>
            <div style="font-size: 14px; color: #333; margin-top: 20px">
              该域名可能被注册局保留、正在审核或限制注册，暂无whois信息
            </div>
          </div>
        </div>
      </div>
    </div>
    <captcha ref="childCaptcha" @custom-event="getCodeEvent"></captcha>
  </layout>
</template>


<script>
import layout from "./components/layout.vue";
import captcha from "components/captcha.vue";
import { getCaptchaWhoisV1, getCaptchaWhoisV2 } from "api/domain.js";
const domain =
  // eslint-disable-next-line max-len
  /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;
export default {
  name: "whoisSearch",
  components: {
    layout,
    captcha
  },
  data() {
    return {
      showNav: false,
      loadings: false,
      search: "",
      info: {
        details: "", //
        dns: [],
        name: "",
        contactMail: "",
        endDateTime: "",
        contactPhone: "",
        registrar: "",
        registrationTime: "",
        status: [],
      },

      // 没有数据
      noData: false,
      // 没有结果
      noResult: false,
    };
  },
  mounted() {
    this.search = this.$route.query.key.toLowerCase() || "";
    if (!this.search) {
      this.$Message.warning("请输入查询的域名信息！");
      this.loadings = false;
      return false;
    }

    // 获取最后一个带点的数据
    const temp = this.search.match(domain);
    if (temp && temp.length > 0) {
      this.search = temp[0];
    } else {
      this.$Message.warning("请输入正确域名信息！");
      return false;
    }
    this.init();
  },
  methods: {
    refreshWhois() {
      this.$refs.childCaptcha.onShow()
    },
    async getCodeEvent(obj) {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV2(this.search, obj.id, obj.code);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 初始化
    async init() {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV1(this.search);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }
      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$nextTick(() => {
        history.pushState("", "", `/whois?key=${this.search}`);
        this.init();
      });
    },
    toRegister(name) {
      window.open(`/search?name=${name}`, "_blank");
    },
  },
};
</script>


<style lang="less" scoped>
.searchBox {
  position: relative;
  top: -180px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  .search-btn {
    width: 190px;
    height: 81px;
    background: linear-gradient(35deg, #ea5d10 0%, #e8340b 100%);
    border-radius: 6px;
    color: #fff;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      margin-right: 20px;
    }
  }
}

.section {
  margin-top: -80px;
  background-color: #f0f3f6;
  padding: 58px 0 64px;
  .whios-info {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .whois-left {
      width: 590px;
      background: #fff;
      padding: 20px 38px;
      .whios-title {
        font-weight: bold;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
      }
      .info-item {
        display: flex;
        line-height: 36px;
        .info-title {
          color: #777777;
          min-width: 130px;
          text-align: right;
        }
        .info-text {
          color: #5555;
          margin-left: 16px;
        }
      }
    }
    .whois-right {
      width: 590px;
      background: #fff;
      padding: 20px 38px;
      margin-left: 18px;
      .eng-title {
        margin-top: 18px;
        color: #333;
        font-weight: bold;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        .title-inner {
          padding-bottom: 20px;
          border-bottom: 3px solid #e9350b;
        }
      }
      .content {
        margin-top: 15px;
        color: #999;
        line-height: 28px;
      }
    }
  }
}

::v-deep .ivu-input {
  height: 80px;
  padding: 0 35px;
  font-size: 16px;
}
::v-deep .ivu-input-icon {
  line-height: 80px;
}
</style>
